(function (){
    'use strict';

    angular
			.module('platformRental')
			.controller('PlatformRentalLoginController', PlatformRentalLoginController)
		PlatformRentalLoginController.$inject = ['AuthService','$state','jwtHelper','AclService'];

    function PlatformRentalLoginController(AuthService, $state, jwtHelper, AclService) {
			var vm = this;
			vm.email = '';
			vm.password = '';
			vm.processing = '';
			vm.submit = submit;
			vm.message = null;

			function activate () { }

			function submit () {
				vm.processing = true;
				AuthService.loginPlatformRental(vm.email, vm.password).then( function () {
					return AuthService.getCurrentUser();
				}).then( function (user) {
					$state.go('root.platformRental.dashboard');
				}).catch(function (err) {
						vm.message = 'Invalid Email / Password';
				}).finally ( function () {
						vm.processing = false;
				});
			}
			activate();
    }
})();